module.exports = __webpack_public_path__ + "img/GA-2018.ade30bf4.png";